<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicant"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.ruzdiStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Прошу удаленно выдать выписку из реестра уведомлений о залоге
          движимого имущества в виде
        </div>
        <div>
          <Step2 :data="statement.ruzdiStep2" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.ruzdiStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">Параметры запроса</div>
        <div>
          <Step3 :data="statement.ruzdiStep3" :subjects="statement.subjects" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.ruzdiStep5">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>
        <div>
          <StepRequisites
            :data="statement.ruzdiStep5"
            :statement-type="StatementType.RUZDI"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>
        <div>
          <StepSign :data="statement.locationStep" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from "@/components/elements/statement/FullStatementView/elements/Subject";
import Step2 from '@/components/elements/statement/FullStatementView/steps/RUZDI/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/RUZDI/Step3';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'RUZDI',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    Step3,
    Step2,
    StepSign,
    StepRequisites,
    Subject,
  },
  data: () => ({
    StatementType,
  }),
};
</script>
